import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateTimeFormats } from '@ge/models/constants';

dayjs.extend(utc);
dayjs.extend(timezone);

export const useSiteTime = (siteTimezone) => {
    const [currentTime, setCurrentTime] = useState('');

    useEffect(() => {
        if (!siteTimezone) return;

        const updateTime = () => {
            const timeInTimezone = dayjs().tz(siteTimezone);
            const formattedTime = timeInTimezone.format(DateTimeFormats.DATE_TIME_TIMEZONE_FORMAT);
            setCurrentTime(formattedTime);
        };

        updateTime();
        const intervalId = setInterval(updateTime, 1000);

        return () => clearInterval(intervalId);
    }, [siteTimezone]);

    return currentTime;
};
